// Project
import { useHicData } from 'src/hooks';

// Feature
import { IRecoupment } from '../types';

export const useRecoupment = (caseId: string, pin: string, isAppUserAgency: boolean) => {
  const queryParameters = {
    case_number: caseId,
    ...(isAppUserAgency && { pin }),
  };

  const results = useHicData<IRecoupment[]>('/recoupment', queryParameters);
  console.log('useRecoupment', results);
  return results;
};
